export const EVENT = "EVENT";

export const VORGANG_UPDATED = "VORGANG_UPDATED";

export const VORGANG_QES_UPDATED = "VORGANG_QES_UPDATED";

export const PPOA_DB_QES_UPDATED = "PPOA_DB_QES_UPDATED";

export const VORGANG_UPDATED_RECORD_ID_FROM_SOCKET_EVENT =
  "VORGANG_UPDATED_RECORD_ID_FROM_SOCKET_EVENT";

export const VORGANG_QES_UPDATED_FROM_SOCKET_EVENT =
  "VORGANG_QES_UPDATED_FROM_SOCKET_EVENT";

export const KEEP_ALIVE = "Keep-Alive";

export const SOCKET_READY_STATE_OPEN = 1;
